import * as React from 'react';
import classNames from 'classnames';

import {
  FilterComponentData,
  FilterViewData,
  SearchFilterComponentData,
  PillsFilterComponentData,
  TabbedFilterComponentData,
  HasPermissionFn,
  GraphQLFilter,
} from '../../@types';

import MultipleSelectFilterContainer from './components/MultipleSelectFilterContainer';
import SearchFilterContainer from './components/SearchFilterContainer';
import PillsFilterContainer from './components/PillsFilterContainer';
import TabbedSelectFilterContainer from './components/TabbedSelectFilterContainer';

export interface Props {
  className?: string;
  partitionId?: 'default' | string;
  data: Omit<FilterViewData, 'type'>;
  baseFilter?: GraphQLFilter;
  permissionFilter?: GraphQLFilter;
  hasPermission?: HasPermissionFn;
}

/**
 * <FilterViewContainer> page
 */
export const FilterViewContainer: React.FunctionComponent<Props> = ({
  className,
  partitionId = 'default',
  data: { className: configClassName, components },
  baseFilter,
  permissionFilter,
  hasPermission,
}) => (
  <div className={classNames(className, configClassName)}>
    {components.map(({ type, permission, ...config }) => {
      if (hasPermission && permission && !hasPermission(permission)) {
        return null;
      }

      if (type === 'checkbox' || type === 'radio' || type === 'select') {
        return (
          <MultipleSelectFilterContainer
            key={config.id}
            partitionId={partitionId}
            baseFilter={baseFilter}
            permissionFilter={permissionFilter}
            config={{ ...config, type } as FilterComponentData}
          />
        );
      }
      if (type === 'search') {
        return (
          <SearchFilterContainer
            key={config.id}
            style={{ minWidth: '21.25rem' }}
            partitionId={partitionId}
            config={config as SearchFilterComponentData}
          />
        );
      }
      if (type === 'pills') {
        return (
          <PillsFilterContainer
            key={config.id}
            partitionId={partitionId}
            baseFilter={baseFilter}
            permissionFilter={permissionFilter}
            config={config as PillsFilterComponentData}
          />
        );
      }
      if (type === 'tabbed') {
        return (
          <TabbedSelectFilterContainer
            key={config.id}
            partitionId={partitionId}
            baseFilter={baseFilter}
            permissionFilter={permissionFilter}
            config={config as TabbedFilterComponentData}
          />
        );
      }
      return null;
    })}
  </div>
);

export default FilterViewContainer;
